import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { ChartFormSubsectionPayload } from "modules/charts-shared";
import { useQueryClient } from "react-query";
import { ChartType } from "types";

type UseUpdateChartApplicationParams = {
  encounterId: string;
  chartCode: string;
  sectionId: string;
  chartType?: ChartType;
};

function useUpdateChartApplication(params: UseUpdateChartApplicationParams) {
  const { encounterId, chartCode, sectionId, chartType } = params;
  const queryClient = useQueryClient();
  return useAxiosMutation(
    ["chartApplication", { chartCode, sectionId }],
    ({
      input,
      chartFavoriteId,
    }: {
      input: ChartFormSubsectionPayload[];
      chartFavoriteId?: string;
    }) =>
      axiosChartInstance.put(
        `v1/chart-application/${encounterId}/${chartCode}/${sectionId}`,
        input,
        { params: { chartFavoriteId } }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "chartDisposition",
          { encounterId, chartCode, sectionId },
        ]);
        queryClient.invalidateQueries([
          "chartSectionInfo",
          { encounterId, chartCode, sectionCode: sectionId },
        ]);
        queryClient.invalidateQueries([
          "chartApplicationHardStops",
          { encounterId, chartCode, chartType: chartType ?? "" },
        ]);
      },
    }
  );
}

export type { UseUpdateChartApplicationParams };
export { useUpdateChartApplication };
